export const ACTION_TYPE_CHANGE_PASSWORD = "CHANGE_PASSWORD_REQUEST";
